import { dcContent } from "../../../services/content";
import { Box, Button, Typography } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { LocalizationContext } from "../../lib/context";
import Image from "next/image";

const ContactDetails = ({
  droner,
  canEdit,
  smAndDown,
  localizedPageContent,
  measurement,
}: {
  droner: any;
  canEdit: boolean;
  smAndDown: boolean | undefined;
  localizedPageContent: any;
  measurement: any;
}) => {
  const router = useRouter();
  const { profilePage, uiGeneral } =
    useContext(LocalizationContext).localeStrings;
  const [showMore, setShowMore] = useState(() => true);

  let visibleBio = droner.bio;
  if (droner.bio.length > 100) visibleBio = droner.bio.slice(0, 100) + "...";

  return (
    <Box className="flex col gap-normal align-items-center w-full">
      <h3
        onClick={() => {
          window.open(
            `https://www.google.com/maps/search/?api=1&query=loc:${droner.address}`,
            "_blank"
          );
        }}
        className="pointer link-hover text-center mt-normal mb-normal"
      >
        {droner.address}
      </h3>

      <Box
        className="flex col align-items-center mt-normal"
        sx={{ gap: "12px" }}
      >
        <h6 className="subtitle-3 primary-lighten-2">
          {droner?.contactEmail
            ? droner.contactEmail
            : dcContent.errors.noEmailSet}
        </h6>
        <h6 className="subtitle-3 primary-lighten-2">
          {droner?.tel ? droner.tel : profilePage.noPhoneNumber}
        </h6>
      </Box>

      {canEdit && !smAndDown && (
        <Button
          type="submit"
          variant="contained"
          sx={{
            backgroundColor: "primary.light",
            width: "100%",
            height: "40px",
            margin: "8px 0 0",
          }}
          children={profilePage.editProfileButton}
          onClick={() => router.push("/settings")}
        />
      )}

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          mt: 2,
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "145px 1fr",
            gap: "40px",
          }}
        >
          <h6 className="subtitle-3">
            {localizedPageContent.freeTravelDistanceRow}:
          </h6>
          <Typography>
            {droner.freeDist} {measurement}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "145px 1fr",
            gap: "40px",
          }}
        >
          <h6 className="subtitle-3">
            {localizedPageContent.maxTravelRangeRow}:
          </h6>
          <Typography>
            {droner.maxRange} {measurement}
          </Typography>
        </Box>

        {droner.equipment?.length > 0 && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "145px 1fr",
              gap: "40px",
            }}
          >
            <h6 className="subtitle-3">{localizedPageContent.equipmentRow}:</h6>
            <Typography textAlign="start">
              {droner.equipment?.map(
                (item: Record<string, unknown>, i: number) => (
                  <>
                    {item}
                    {i < droner.equipment.length - 1 && ", "}
                  </>
                )
              )}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: droner?.userCertificate ? "grid" : "none",
            gridTemplateColumns: "145px 1fr",
            gap: "40px",
          }}
        >
          <h6 className="subtitle-3">{profilePage.certification}:</h6>
          <a href={droner?.userCertificate} target="_blank" rel="noreferrer">
            <Image src="/assets/pdf-icon.png" width="32" height="32" alt="" />
          </a>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "145px 1fr",
            gap: "40px",
          }}
        >
          <h6 className="subtitle-3">{profilePage.socialSites}:</h6>
          <Box sx={{ display: "flex", gap: 2 }}>
            <FacebookIcon sx={{ color: "black" }} className="pointer" />
            <LinkedInIcon sx={{ color: "black" }} className="pointer" />
            <InstagramIcon sx={{ color: "black" }} className="pointer" />
            <YouTubeIcon className="pointer" sx={{ color: "black" }} />
          </Box>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "145px 1fr",
            gap: "40px",
          }}
        >
          <h6 className="subtitle-3">{localizedPageContent.projects}:</h6>
          <Typography>{droner.projects?.length ?? "0"}</Typography>
        </Box>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "145px 1fr",
            gap: "40px",
          }}
        >
          <h6 className="subtitle-3">{localizedPageContent.aboutMeRow}:</h6>
        </Box>
        <div
          style={{
            height: showMore ? "auto" : "145px",
            overflow: "hidden",
          }}
        >
          {showMore ? (
            <Typography textAlign="left">{visibleBio}</Typography>
          ) : (
            <Typography textAlign="left">{droner.bio}</Typography>
          )}
        </div>
        {droner.bio.length > 100 && (
          <span
            className="button primary-lighten-2 pointer"
            style={{
              marginTop: "-6px",
              textAlign: "left",
              width: "max-content",
            }}
            children={
              !showMore ? uiGeneral.showLessButton : uiGeneral.showMoreButton
            }
            onClick={() => setShowMore((prevState) => !prevState)}
          />
        )}
      </Box>
    </Box>
  );
};

export default ContactDetails;
